import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { NewClientOfferLayout } from '@/features/new-client-offer';
import { formatDocumentTitle } from '@/lib/document-title';

/** Layout for Overview | Guests | Setup; it owns the offer query so tabs share one version. */
export const Route = createFileRoute('/_auth/$orgId/marketing/new-client-offer')({
  component: NewClientOfferRoute,
});

function NewClientOfferRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('New Client Offer', 'Marketing')}</title>
      </Helmet>
      <NewClientOfferLayout routeOrgId={orgId} />
    </>
  );
}
